import { RequestStatus } from '@lib/plugin-redux-core';
import { GlobalForm, FormSummary as DomainFormSummary } from '@module/form';
import { RootReducerState } from '../../root.reducer';

// ─── Global Forms ─────────────────────────────────────────────────────────────

export const globalFormsSelector = (state: RootReducerState): GlobalForm[] =>
  state.formEdit.globalForms || [];

export const getGlobalFormsStatusSelector = (state: RootReducerState): RequestStatus =>
  state.formEdit.getGlobalFormsStatus;

export const globalFormsSearchResultSelector = (state: RootReducerState): GlobalForm[] =>
  state.formEdit.globalFormsSearchResult || [];

export const searchGlobalFormsStatusSelector = (state: RootReducerState): RequestStatus =>
  state.formEdit.searchGlobalFormsStatus;

export const globalFormsNextTokenSelector = (state: RootReducerState): string | null =>
  state.formEdit.globalFormsNextToken ?? null;

export const globalFormsSearchNextTokenSelector = (state: RootReducerState): string | null =>
  state.formEdit.globalFormsSearchNextToken ?? null;

// ─── Local Forms ──────────────────────────────────────────────────────────────

export const localFormsSelector = (state: RootReducerState): DomainFormSummary[] =>
  state.formEdit.localForms || [];

export const getLocalFormsStatusSelector = (state: RootReducerState): RequestStatus =>
  state.formEdit.getLocalFormsStatus;

export const localFormsSearchResultSelector = (state: RootReducerState): DomainFormSummary[] =>
  state.formEdit.localFormsSearchResult || [];

export const searchLocalFormsStatusSelector = (state: RootReducerState): RequestStatus =>
  state.formEdit.searchLocalFormsStatus;

export const localFormsNextTokenSelector = (state: RootReducerState): string | null =>
  state.formEdit.localFormsNextToken ?? null;

export const localFormsSearchNextTokenSelector = (state: RootReducerState): string | null =>
  state.formEdit.localFormsSearchNextToken ?? null;

export const localFolderNextTokenSelector = (state: RootReducerState): string | null =>
  state.formEdit.localFolderNextToken ?? null;

export const localFolderSearchNextTokenSelector = (state: RootReducerState): string | null =>
  state.formEdit.localFolderSearchNextToken ?? null;
